import PropTypes from 'prop-types';
import React from 'react';

const ImageBanner = ({ content, breakpoint }) => {
  try {
    if (content && content.structuredImageData) {
      let image;
      let altText;
      let type = 'image';

      if (content.structuredImageData.desktop.imageURL) {
        image =
          breakpoint === 'mobile'
            ? content.structuredImageData.mobile.imageURL
            : content.structuredImageData.desktop.imageURL;

        altText =
          breakpoint === 'mobile'
            ? content.structuredImageData.mobile.altText
            : content.structuredImageData.desktop.altText;
      } else if (content.structuredImageData.desktop.gifURL) {
        if (breakpoint === 'mobile') return null;
        image = content.structuredImageData.desktop.gifURL;
        altText = content.structuredImageData.desktop.altText;
        type = 'gif';
      } else {
        return null;
      }

      if (content.link) {
        return (
          <a className="ImageBanner" href={content.link} alt={altText} data-em={content.DataEMTag}>
            <img
              src={image}
              alt={altText}
              className={type === 'gif' ? 'rs-gif-banner' : ''}
              loading="lazy"
            />
          </a>
        );
      }
      return (
        <img
          src={image}
          alt={altText}
          className={`ImageBanner ${type === 'gif' && 'rs-gif-banner'}`}
          loading="lazy"
        />
      );
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default ImageBanner;

ImageBanner.propTypes = {
  content: PropTypes.object.isRequired,
  breakpoint: PropTypes.string.isRequired,
};
